define("shared/components/shared/ui/report/settings-wrapper", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@ember/utils", "@latermedia/ember-later-analytics/utils", "@ember/runloop", "later/errors/credentials"], function (_exports, _component, _templateFactory, _component2, _object, _service, _utils, _utils2, _runloop, _credentials) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@latermedia/ember-later-analytics/utils",0,"@ember/runloop",0,"later/errors/credentials",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert this.fetchRecentReport}}>
    {{ yield this.report this.reportStatus this.reportActions }}
  </div>
  */
  {
    "id": "0vj58RSZ",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"fetchRecentReport\"]]],null],[12],[1,\"\\n  \"],[18,1,[[30,0,[\"report\"]],[30,0,[\"reportStatus\"]],[30,0,[\"reportActions\"]]]],[1,\"\\n\"],[13]],[\"&default\"],false,[\"did-insert\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/report/settings-wrapper.hbs",
    "isStrictMode": false
  });

  let SettingsWrapperComponent = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class SettingsWrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "credentialStatus", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "performanceReport", _descriptor5, this);

      _initializerDefineProperty(this, "router", _descriptor6, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor7, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor8, this);
    }

    get report() {
      return this.performanceReport.analyticsPerformanceReport;
    }

    get showCreateReport() {
      return !this.isReportPresent || this.isReportDisabled;
    }

    get isReportPresent() {
      return this.performanceReport.isReportPresent;
    }

    get isReportDisabled() {
      return this.performanceReport.isReportDisabled;
    }

    get isReportBeingGenerated() {
      return this.performanceReport.isReportBeingGenerated;
    }

    get isLoadingReport() {
      return this.performanceReport.isLoading;
    }

    get isMissingIndustry() {
      var _this$args$socialProf;

      return (0, _utils.isBlank)((_this$args$socialProf = this.args.socialProfile) === null || _this$args$socialProf === void 0 ? void 0 : _this$args$socialProf.industry);
    }

    get reportViews() {
      return this.performanceReport.reportViews || 0;
    }

    get isUpdating() {
      return this.performanceReport.isUpdating;
    }

    get isAutoUpdateEnabled() {
      var _this$report;

      return (_this$report = this.report) === null || _this$report === void 0 ? void 0 : _this$report.autoUpdateEnabled;
    }

    get isBenchmarkEngagementEnabled() {
      var _this$report2;

      return (_this$report2 = this.report) === null || _this$report2 === void 0 ? void 0 : _this$report2.benchmarkEngagementEnabled;
    }

    get canManualUpdate() {
      return !this.performanceReport.reportRecentlyUpdated && !this.performanceReport.isUpdating;
    }

    get showUpsell() {
      return ['Free', 'Basics', 'Starter'].includes(this.subscriptions.planName) && !this.subscriptions.hasActiveTrial && !this.auth.currentUserModel.admin;
    }

    get showTrialUpSell() {
      return ['Free', 'Basics', 'Starter'].includes(this.subscriptions.planName) && this.subscriptions.hasActiveTrial && !this.auth.currentUserModel.admin;
    }

    get page() {
      return this.performanceReport.page;
    }

    get preview() {
      var _this$report3, _this$report3$preview, _this$report5, _this$report5$preview;

      const engagementSignificantDigits = 2;
      const preview = {};

      if ((0, _utils.isPresent)((_this$report3 = this.report) === null || _this$report3 === void 0 ? void 0 : (_this$report3$preview = _this$report3.preview) === null || _this$report3$preview === void 0 ? void 0 : _this$report3$preview.profile_average_engagement)) {
        var _this$report4, _this$report4$preview;

        const profileMeta = (0, _utils2.convertNumberToMeta)(Number((_this$report4 = this.report) === null || _this$report4 === void 0 ? void 0 : (_this$report4$preview = _this$report4.preview) === null || _this$report4$preview === void 0 ? void 0 : _this$report4$preview.profile_average_engagement) * 100, true, null, false, false);
        preview.profileAverageEngagement = (0, _utils2.convertMetaToString)(profileMeta, true, engagementSignificantDigits, false);
      }

      if ((0, _utils.isPresent)((_this$report5 = this.report) === null || _this$report5 === void 0 ? void 0 : (_this$report5$preview = _this$report5.preview) === null || _this$report5$preview === void 0 ? void 0 : _this$report5$preview.industry_average_engagement)) {
        var _this$report6, _this$report6$preview;

        const industryMeta = (0, _utils2.convertNumberToMeta)(Number((_this$report6 = this.report) === null || _this$report6 === void 0 ? void 0 : (_this$report6$preview = _this$report6.preview) === null || _this$report6$preview === void 0 ? void 0 : _this$report6$preview.industry_average_engagement) * 100, true, null, false, false);
        preview.industryAverageEngagement = (0, _utils2.convertMetaToString)(industryMeta, true, engagementSignificantDigits, false);
      }

      return preview;
    }

    get reportStatus() {
      var _this$report7, _this$report8;

      return {
        isReportPresent: this.isReportPresent,
        isReportDisabled: this.isReportDisabled,
        isReportBeingGenerated: this.isReportBeingGenerated,
        isLoadingReport: this.isLoadingReport,
        isUpdating: this.isUpdating,
        isMissingIndustry: this.isMissingIndustry,
        hasMissingProfessionalPermission: this.performanceReport.hasMissingProfessionalPermission,
        canManualUpdate: this.canManualUpdate,
        isAutoUpdateEnabled: (_this$report7 = this.report) === null || _this$report7 === void 0 ? void 0 : _this$report7.autoUpdateEnabled,
        isBenchmarkEngagementEnabled: this.isBenchmarkEngagementEnabled,
        reportViews: this.reportViews,
        preview: this.preview,
        isLoadingPreview: this.performanceReport.isLoadingPreview,
        reportUrl: (_this$report8 = this.report) === null || _this$report8 === void 0 ? void 0 : _this$report8.url,
        showCreateReport: this.showCreateReport,
        showUpsell: this.showUpsell,
        showTrialUpsell: this.showTrialUpSell,
        page: this.page
      };
    }

    get reportActions() {
      return {
        createReport: this.createReport,
        fetchReport: this.fetchReport,
        manuallyUpdateReport: this.manuallyUpdateReport,
        toggleReportAutoUpdate: this.toggleReportAutoUpdate,
        toggleEngagementIndustryBenchmark: this.toggleEngagementIndustryBenchmark,
        toggleReport: this.toggleReport,
        connectInstagramBusinessAccount: this.connectInstagramBusinessAccount,
        routeToChangeIndustry: this.routeToChangeIndustry,
        setIsLoadingPreview: this.setIsLoadingPreview
      };
    }

    createReport() {
      this.performanceReport.createReport();
    }

    fetchRecentReport() {
      this.performanceReport.fetchRecentReport();
    }

    manuallyUpdateReport() {
      this.performanceReport.manuallyUpdateReport();
    }

    toggleReportAutoUpdate() {
      this.performanceReport.toggleReportAutoUpdate();
    }

    toggleEngagementIndustryBenchmark() {
      this.performanceReport.toggleEngagementIndustryBenchmark();
    }

    async toggleReport() {
      await this.performanceReport.toggleReport();
    }

    connectInstagramBusinessAccount() {
      this.instagramBusiness.refreshBusinessAccountEndpoint(this.performanceReport.socialProfile).catch(error => {
        if (error instanceof _credentials.CredentialsNotFoundError) {
          error.resolve.call(this, this.performanceReport.socialProfile);
        } else {
          this.errors.log(error);
        }
      });
      this.credentialStatus.checkBrokenProfiles();
    }

    routeToChangeIndustry(event) {
      event.preventDefault();
      this.router.transitionTo('account.groups.group.social_profiles.edit', this.auth.currentGroup.id, this.args.socialProfile.id, {
        queryParams: {
          tab: 'industry'
        }
      });
    }

    setIsLoadingPreview() {
      let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _runloop.run.later(() => {
        this.performanceReport.setIsLoadingPreview(state);
      }, 1500);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "performanceReport", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "createReport", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchRecentReport", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchRecentReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "manuallyUpdateReport", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "manuallyUpdateReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleReportAutoUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleReportAutoUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleEngagementIndustryBenchmark", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEngagementIndustryBenchmark"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleReport", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "connectInstagramBusinessAccount", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "connectInstagramBusinessAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "routeToChangeIndustry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "routeToChangeIndustry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsLoadingPreview", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsLoadingPreview"), _class.prototype)), _class));
  _exports.default = SettingsWrapperComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SettingsWrapperComponent);
});